export enum LocalStorageKeys {}

export const clearStorage = () => {
  const keysToPersist = ['navigationParams'];

  const keys = Object.keys(localStorage);

  keys.forEach((key) => {
    if (!keysToPersist.includes(key)) {
      localStorage.removeItem(key);
    }
  });

  sessionStorage.clear();
};

export const setValueInLocalStorage = <T>(key: string, value: T) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export function getValueFromLocalStorage<T>(key: string): T | null {
  try {
    const value = localStorage.getItem(key);
    if (value) {
      return JSON.parse(value) as T;
    }
    return null;
  } catch (error) {
    console.error(`Error retrieving value from localStorage: ${error}`);
    return null;
  }
}

export function deleteValueFromLocalStorage(key: string) {
  localStorage.removeItem(key);
}
